export default {
  "content": "<path d=\"M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M351.82 271.87v-16A96.15 96.15 0 00184.09 192m-24.2 48.17v16A96.22 96.22 0 00327.81 320\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M135.87 256l23.59-23.6 24.67 23.6m192 0l-23.59 23.6-24.67-23.6\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};